function Vignette({text, icon}){

    return(
        <div>
            <span>{text}</span>
        </div>
    );
}

export default Vignette;